<template>
  <section v-if="photos" class="photos card tw-px-6 tw-py-4">
    <h3 class="tw-font-bold">{{ $t('Photos') }} ({{ photos.length }})</h3>

    <div class="tw-grid tw-grid-cols-4 tw-gap-1 tw-py-2.5">
      <NuxtLink
        v-for="pic of previewPhotos"
        :key="pic.id"
        :to="`/trips/${props.tripId}/photos?pid=${pic.id}`"
      >
        <img
          loading="lazy"
          class="tw-aspect-square tw-cursor-pointer tw-object-cover"
          :src="pic.thumb"
        />
      </NuxtLink>
    </div>

    <NuxtLink class="tw-text-sm tw-text-riser-blue" :to="`/trips/${props.tripId}/photos`">
      {{ $t('Show-all') }}
    </NuxtLink>
  </section>
</template>

<script setup lang="ts">
import { type MainSectionPhoto } from '~/types/trip'

const props = withDefaults(
  defineProps<{
    tripId: number
    photos: MainSectionPhoto[]
    maxVisible?: number
  }>(),
  {
    maxVisible: 8
  }
)

const previewPhotos = computed(() => {
  return props.photos.slice(0, props.maxVisible)
})
</script>
